import React from "react";
import { useNavigate } from "react-router-dom";

import LaunchBanner from "../components/LaunchBanner";
import Header from "../components/Header";
import CopyrightFooter from "../components/CopyrightFooter";
import "../styles/HowItWorks.css";

function HowItWorks() {
  const navigate = useNavigate();
  const goToSignup = () => navigate("/signup");

  return (
    <>
      <LaunchBanner goToSignup={goToSignup} />
      <Header />

      <div className="landing-page">
        <section className="content-section how-it-works-hero">
          <div className="section-container how-it-works-hero-container">
            <h1 className="section-title how-it-works-hero-title">
              How It Works
            </h1>
            <p className="content-description how-it-works-hero-subtitle">
              Let's plan your dream wedding together
            </p>
          </div>
        </section>

        <section className="content-section video-action-section">
          <div className="section-container">
            <div className="content-grid video-action-grid">
              <div className="text-content">
                <h2 className="section-title video-action-heading">
                  See It in Action
                </h2>
                <p className="content-description video-action-text">
                  This quick walkthrough will show you how to choose a location
                  and see your forecasted weather for your special day.
                </p>
              </div>

              <div className="video-container">
                <video controls poster="/videos/video-poster.jpg">
                  <source src="/videos/couples-demo.mp4" type="video/mp4" />
                  Your browser doesn’t support HTML5 video.
                </video>
              </div>
            </div>

            <div className="video-action-button-container">
              <a href="/pricing/couples" className="btn btn-primary">
                Get Started
              </a>
            </div>
          </div>
        </section>

        <div className="footer-wrapper-spaced">
          <CopyrightFooter />
        </div>
      </div>
    </>
  );
}

export default HowItWorks;
